import { defineStore } from "pinia";
import { computed, ref } from "vue";
import axios from "axios";
import route from "ziggy-js";

export const usePreloadStore = defineStore("preload", () => {
    // State
    const data = ref({
        locations: null,
        categories: null,
        users: null,
        assets: null,
    });

    // Generic internal function to fetch data and update state.
    const load = async (key, routeName) => {
        const { data: r } = await axios.get(route(routeName));
        data.value[key] = r.data;
    };

    // Locations
    const loadLocations = async (reset = false) => {
        if (!reset && data.value.locations !== null) {
            return;
        }

        return load("locations", "api.preload.locations");
    };

    const locations = computed(() => {
        return data.value.locations;
    });

    // Categories
    const loadCategories = async (reset = false) => {
        if (!reset && data.value.categories !== null) {
            return;
        }

        return load("categories", "api.preload.categories");
    };

    const categories = computed(() => {
        return data.value.categories ?? [];
    });

    // Users
    const loadUsers = async (reset = false) => {
        if (!reset && data.value.users !== null) {
            return;
        }

        return load("users", "api.preload.users");
    };

    const users = computed(() => {
        return data.value.users;
    });

    // Assets
    const loadAssets = async (reset = false) => {
        if (!reset && data.value.assets !== null) {
            return;
        }

        return load("assets", "api.preload.assets");
    };

    const assets = computed(() => {
        return data.value.assets;
    });

    const clear = () => {
        data.value = {
            locations: null,
            categories: null,
            users: null,
            assets: null,
        };
    };

    return {
        loadLocations,
        locations,
        loadCategories,
        categories,
        loadUsers,
        users,
        loadAssets,
        assets,
        clear,
    };
});
